import React, { useState } from 'react';
import { FaDollarSign, FaEuroSign, FaYenSign, FaPoundSign, FaRupeeSign } from 'react-icons/fa';
import { FiDollarSign } from 'react-icons/fi'; // For Australian and Canadian Dollar
import { GiBrazilFlag } from 'react-icons/gi'; // Placeholder for Brazilian Real
import { AiOutlineDollarCircle } from 'react-icons/ai'; // Placeholder for currencies like Rand, Ruble

const currencyOptions = [
  { label: 'INR - Indian Rupee', icon: <FaRupeeSign /> },
  { label: 'USD - US Dollar', icon: <FaDollarSign /> },
  { label: 'EUR - Euro', icon: <FaEuroSign /> },
  { label: 'JPY - Japanese Yen', icon: <FaYenSign /> },
  { label: 'GBP - British Pound', icon: <FaPoundSign /> },
  { label: 'AUD - Australian Dollar', icon: <FiDollarSign /> },
  { label: 'CAD - Canadian Dollar', icon: <FiDollarSign /> },
  { label: 'CHF - Swiss Franc', icon: <AiOutlineDollarCircle /> },
  { label: 'CNY - Chinese Yuan', icon: <AiOutlineDollarCircle /> },
  { label: 'BRL - Brazilian Real', icon: <GiBrazilFlag /> },
  { label: 'ZAR - South African Rand', icon: <AiOutlineDollarCircle /> },
  { label: 'RUB - Russian Ruble', icon: <AiOutlineDollarCircle /> },
  { label: 'MXN - Mexican Peso', icon: <AiOutlineDollarCircle /> },
];

const Currency = () => {
  const [selectedCurrencies, setSelectedCurrencies] = useState([]);

  const handleCurrencyClick = (currency) => {
    setSelectedCurrencies((prevSelected) =>
      prevSelected.includes(currency)
        ? prevSelected.filter((item) => item !== currency)
        : [...prevSelected, currency]
    );
  };

  return (
    <div className="p-4 bg-gray-100 min-h-screen">
      <h1 className="text-2xl poppins-bold mb-6">Select Currencies</h1>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2">
        {currencyOptions.map((currency, index) => (
          <div
            key={index}
            onClick={() => handleCurrencyClick(currency.label)}
            className={`cursor-pointer px-auto py-2 poppins-regular rounded-full border flex items-center justify-center transition-colors duration-200 ${
              selectedCurrencies.includes(currency.label)
                ? 'bg-black text-white'
                : 'bg-white text-gray-700 border-gray-300'
            }`}
          >
            <span className="mr-2">{currency.icon}</span>
            {currency.label}
          </div>
        ))}
      </div>
      <div className="col-span-3 text-center mt-6">
        <button
          type="submit"
          className="w-full py-3 px-4 bg-black text-white font-semibold rounded-md shadow focus:ring focus:ring-opacity-75 focus:ring-black"
        >
          Submit
        </button>
      </div>
    </div>
  );
};

export default Currency;
